import React from "react";

function Footer() {
  return (
    <footer>
      <span className="px-2"></span>© 2024 Portfolio | Fatma Kurtgozu
    </footer>
  );
}

export default Footer;
